import { render, staticRenderFns } from "./FrontServiceWagesAndAllowanceRecord.vue?vue&type=template&id=1e9b8045&scoped=true"
import script from "./FrontServiceWagesAndAllowanceRecord.vue?vue&type=script&lang=js"
export * from "./FrontServiceWagesAndAllowanceRecord.vue?vue&type=script&lang=js"
import style0 from "./FrontServiceWagesAndAllowanceRecord.vue?vue&type=style&index=0&id=1e9b8045&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9b8045",
  null
  
)

export default component.exports